import { render, staticRenderFns } from "./WalletDetail.vue?vue&type=template&id=6c720703&scoped=true&lang=html&"
import script from "./WalletDetail.vue?vue&type=script&lang=js&"
export * from "./WalletDetail.vue?vue&type=script&lang=js&"
import style0 from "./WalletDetail.vue?vue&type=style&index=0&id=6c720703&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c720703",
  null
  
)

export default component.exports